import React, { Suspense } from 'react';
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from 'react-router-dom';
import Login from 'pages/Main/Login';
import ChangePasswordByUser from 'pages/Main/ChangePasswordByUser';
import ForgotPassword from 'pages/Main/ForgotPassword';
import XeroSignUp from 'pages/Main/XeroSignUp';
import PrivateRoute from 'components/PrivateRoute';
import NonUserRoute from 'components/NonUserRoute';
import FullLoader from 'components/Loader/FullLoader';
import ViewPortal from 'pages/ProjectBudget/DayworkDocket/ClientApprovalTemplates/ViewPortal';
import SignPortal from 'pages/ProjectBudget/DayworkDocket/ClientApprovalTemplates/SignPortal';
import QRScreens from 'pages/Main/QRScreens';

const Dashboard = React.lazy(() => import('../pages/Home'));

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/login" element={<NonUserRoute />}>
        <Route path="/login" element={<Login />} />
      </Route>
      <Route path="/change-password" element={<NonUserRoute />}>
        <Route path="/change-password" element={<ChangePasswordByUser />} />
      </Route>
      <Route path="/forgot-password" element={<NonUserRoute />}>
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>
      <Route path="/forgot-password" element={<NonUserRoute />}>
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Route>
      <Route path="/xerosignup" element={<NonUserRoute />}>
        <Route path="/xerosignup" element={<XeroSignUp />} />
      </Route>
      <Route path="/daywork-docket/client-signature" element={<NonUserRoute />}>
        <Route
          path="/daywork-docket/client-signature"
          element={<ViewPortal />}
        />
      </Route>
      <Route path="/access-daywork" element={<NonUserRoute />}>
        <Route path="/access-daywork" element={<SignPortal />} />
      </Route>
      <Route path="/forms-qr/*" element={<NonUserRoute />}>
        <Route path="*" element={<QRScreens />} />
      </Route>

      <Route path="*" element={<PrivateRoute />}>
        <Route
          path="*"
          element={
            <Suspense fallback={<FullLoader />}>
              <Dashboard />
            </Suspense>
          }
        />
      </Route>
    </>,
  ),
);

export default router;
